module.exports = __webpack_public_path__ + "static/media/punk_female-transparent.1385594a.png";